import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import antLocale from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import RouterLayout from "@/components/RouterLayout/index.vue";
import AppLayout from "@/layout/index.vue";
import router from "./router";
import { onMounted } from "vue";
import { useUserStore } from "@/store/modules/user/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

dayjs.locale("zh-cn");
const userStore = useUserStore();
if ((window as any).microApp) {
  (window as any).microApp.addDataListener((data: any) => {
    // 当基座下发跳转指令时进行跳转
    if (data.path) {
      router.replace(data.path);
    }
  });
}

onMounted(async () => {
  await userStore.fetchUserInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _unref(antLocale) }, {
    default: _withCtx(() => [
      _createVNode(AppLayout, null, {
        default: _withCtx(() => [
          _createVNode(RouterLayout)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})